<script setup lang="ts">
import { ref } from 'vue';
import OnBoarding from './OnBoarding.vue';


 const step = ref(0);

</script>
<template>
    <template v-if="step == 0">
    <div class="container">
        <img src="/xybutterfly-v3-teal.svg" alt="XYButterfly Logo" class="logo">
        <p>Enhancing leadership and project follow-up with human insight and technological precision.</p>
        <button class="get-started" @click="step = 1">Get Started</button>
        <a href="https://demo.xybutterfly.com" class="menu">Demo</a>
        <a href="https://app.xybutterfly.com" class="menu">I am ready</a>
        <p class="footer">Delivered by <a href="https://hvana.no" style="color: var(--color-link);">Hva Nå? AS</a></p>
        <p class="footer">
            <a href="#cookies" style="color: var(--color-link);">Cookie Policy</a> |
            <a href="#terms" style="color: var(--color-link);">Terms of Service</a> |
            <a href="#membership" style="color: var(--color-link);">Membership Terms</a>
        </p>
    </div>
    </template>
    <template v-if="step == 1">
        <OnBoarding></OnBoarding>
        <button class="ok" @click="step = 0">Back</button>
    </template>
</template>
<style scoped>
.container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 20px;
    background-color: var(--color-background);
}

.ok {
    padding: 12px 20px;
}

.logo {
    width: 80%;
    max-width: 250px;
    margin-bottom: 20px;
}
.menu {
    display: block;
    width: 100%;
    max-width: 300px;
    padding: 12px;
    margin: 10px 0;
    text-decoration: none;
    text-align: center;
    font-size: 18px;
    border-radius: 8px 0;
    background-color: var(--color-menu);
    border-bottom: 2px solid var(--color-menu-divider);
    border-top: 1px solid var(--color-menu-divider-2);
    color: var(--color-text);
    transition: background-color 0.3s ease-in-out;
}
.menu:hover {
    background-color: var(--color-menu-divider);
}
.footer {
    margin-top: 30px;
    font-size: 14px;
    color: var(--color-text-soft);
}
.get-started {
    margin-top: 20px;
    padding: 12px 20px;
    font-size: 18px;
    border-radius: 8px;
    background-color: var(--xyb-green-dark-1);
    color: var(--color-text);
    border: none;
    cursor: pointer;
    transition: background-color 0.3s ease-in-out;
}
.get-started:hover {
    background-color: var(--xyb-dark-warn-2);
}
</style>
